/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Consistency_NoteInputs */

const en_us2_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned is the days per week in your training profile today.`)
};

const pt_br2_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O planejado é o número de dias por semana do seu perfil de treino hoje.`)
};

const es_419_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo planeado son los días por semana de tu perfil de entrenamiento actual.`)
};

const pt_pt2_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O planeado é o número de dias por semana do teu perfil de treino hoje.`)
};

const fr_fr2_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le prévu, c'est le nombre de jours par semaine de ton profil d'entraînement actuel.`)
};

const de_de2_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplant sind die Tage pro Woche aus deinem aktuellen Trainingsprofil.`)
};

const it_it2_progress_report_consistency_note = /** @type {(inputs: Progress_Report_Consistency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I previsti sono i giorni a settimana del tuo profilo di allenamento di oggi.`)
};

/**
* | output |
* | --- |
* | "Planned is the days per week in your training profile today." |
*
* @param {Progress_Report_Consistency_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_consistency_note = /** @type {((inputs?: Progress_Report_Consistency_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Consistency_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_consistency_note(inputs)
	if (locale === "es-419") return es_419_progress_report_consistency_note(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_consistency_note(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_consistency_note(inputs)
	if (locale === "de-DE") return de_de2_progress_report_consistency_note(inputs)
	if (locale === "it-IT") return it_it2_progress_report_consistency_note(inputs)
	return en_us2_progress_report_consistency_note(inputs)
});
export { progress_report_consistency_note as "progress-report.consistency_note" }